/**
 * tdesign v1.5.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../../_chunks/dep-fa22eda7.mjs';
import { i as isFunction_1 } from '../../_chunks/dep-1f286011.mjs';
import { i as isBoolean_1 } from '../../_chunks/dep-44e322cb.mjs';
import { computed, nextTick } from 'vue';
import { d as dayjs } from '../../_chunks/dep-0927ceb7.mjs';
import { COMPONENT_NAME } from '../const.mjs';
import '../../hooks/useConfig.mjs';
import { useConfig } from '../../config-provider/useConfig.mjs';
import '../../_chunks/dep-8a0ff305.mjs';
import '../../_chunks/dep-34428f12.mjs';
import '../../_chunks/dep-1c40d002.mjs';
import '../../_chunks/dep-3ced59c9.mjs';
import '../../_chunks/dep-61150968.mjs';
import '../../_chunks/dep-4371fb57.mjs';
import '../../_chunks/dep-31d34e52.mjs';
import '../../_chunks/dep-67e8723b.mjs';
import '../../_chunks/dep-0bf03d55.mjs';
import '../../_chunks/dep-5b5daf08.mjs';
import '../../_chunks/dep-95049222.mjs';
import '../../_chunks/dep-ac19a2b6.mjs';
import '../../_chunks/dep-90d97bcb.mjs';
import '../../_chunks/dep-c8679a16.mjs';
import '../../_chunks/dep-939a74d6.mjs';
import '../../_chunks/dep-e9ff4ce8.mjs';
import '../../_chunks/dep-c54c9f32.mjs';
import '../../_chunks/dep-e4f65bc4.mjs';
import '../../_chunks/dep-45572c49.mjs';
import '../../_chunks/dep-1aa18f5f.mjs';
import '../../_chunks/dep-e09a06d8.mjs';
import '../../_chunks/dep-07f3660d.mjs';
import '../../_chunks/dep-0d3220b0.mjs';
import '../../_chunks/dep-895678a0.mjs';
import '../../_chunks/dep-b2bdc7b9.mjs';
import '../../_chunks/dep-0f45a6e0.mjs';
import '../../_chunks/dep-b390ff23.mjs';
import '../../_chunks/dep-35a4fd8d.mjs';
import '../../_chunks/dep-54378e60.mjs';
import '../../_chunks/dep-25b8bf4b.mjs';
import '../../_chunks/dep-c40264c0.mjs';
import '../../_chunks/dep-9d499243.mjs';
import '../../_common/js/global-config/default-config.mjs';
import '../../_common/js/global-config/locale/zh_CN.mjs';
import '../../_chunks/dep-f0bd05df.mjs';
import '../../config-provider/type.mjs';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var getDefaultControllerConfigData = function getDefaultControllerConfigData() {
  var visible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  return {
    visible: visible,
    disabled: false,
    mode: {
      visible: true,
      radioGroupProps: {}
    },
    year: {
      visible: true,
      selectProps: {}
    },
    month: {
      visible: true,
      selectProps: {}
    },
    weekend: {
      visible: true,
      showWeekendButtonProps: {},
      hideWeekendButtonProps: {}
    },
    current: {
      visible: true,
      currentDayButtonProps: {},
      currentMonthButtonProps: {}
    }
  };
};
function userController(props, state) {
  var _useConfig = useConfig(COMPONENT_NAME),
    globalConfig = _useConfig.globalConfig;
  var options = computed(function () {
    var dayJsFilterDate = dayjs("".concat(state.curSelectedYear, "-").concat(state.curSelectedMonth));
    var re = {
      isShowWeekend: state.isShowWeekend,
      filterDate: dayJsFilterDate.toDate(),
      formattedFilterDate: dayJsFilterDate.format(props.format),
      mode: state.curSelectedMode
    };
    return re;
  });
  var configData = computed(function () {
    var _ref, _props$controllerConf;
    var controllerConfig = (_ref = (_props$controllerConf = props.controllerConfig) !== null && _props$controllerConf !== void 0 ? _props$controllerConf : globalConfig.value.controllerConfig) !== null && _ref !== void 0 ? _ref : true;
    if (isBoolean_1(controllerConfig)) {
      return getDefaultControllerConfigData(controllerConfig);
    }
    return _objectSpread(_objectSpread({}, getDefaultControllerConfigData()), controllerConfig);
  });
  var visible = computed(function () {
    return !!configData.value && configData.value.visible;
  });
  function checkControllerVisible(name) {
    var re = true;
    var conf = configData.value;
    if (!conf || !conf.visible || conf[name] === false || conf[name] && !conf[name].visible) {
      re = false;
    }
    return re;
  }
  function checkControllerDisabled(name, propsName) {
    var re = false;
    var conf = configData.value;
    if (conf && (conf.disabled || conf[name] && conf[name][propsName] && conf[name][propsName].disabled)) {
      re = true;
    }
    return re;
  }
  function emitControllerChange() {
    nextTick(function () {
      isFunction_1(props.onControllerChange) && props.onControllerChange(_objectSpread({}, options.value));
    });
  }
  return {
    options: options,
    configData: configData,
    visible: visible,
    checkControllerVisible: checkControllerVisible,
    checkControllerDisabled: checkControllerDisabled,
    emitControllerChange: emitControllerChange
  };
}

export { userController };
//# sourceMappingURL=useController.mjs.map
